var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0, _path1, _g1, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_567)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.02979 0H25.0302V20.04H-5.02979V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.02979 0H25.0302V6.012H-5.02979V0Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.02979 14.0281H25.0302V20.0401H-5.02979V14.0281Z",
    fill: "#166734"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42041 15.9695L6.63747 16.0947L12.4882 5.96088C12.8303 5.86922 13.0182 5.54372 13.2061 5.21834C13.3314 5.00148 13.8323 4.13368 14.0496 3.0061C13.1816 3.75796 12.6806 4.6257 12.5554 4.84262C12.3675 5.168 12.1796 5.4935 12.2712 5.83564L6.42041 15.9695Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6605 16.1803L6.33496 15.9924L12.2045 5.82625C12.1217 5.46863 12.3146 5.13459 12.5013 4.81131C13.0233 3.90715 13.6092 3.30485 14.0087 2.95877L14.1454 2.84033L14.1112 3.01795C14.0111 3.53737 13.7823 4.34617 13.2604 5.24965C13.0737 5.57309 12.8808 5.90709 12.5299 6.01413L6.6605 16.1803ZM6.50608 15.9465L6.61464 16.0092L12.447 5.90711L12.4721 5.90041C12.7891 5.81549 12.9653 5.51031 13.1518 5.18723C13.6064 4.40015 13.8348 3.68703 13.9493 3.17995C13.5677 3.53243 13.0644 4.08653 12.6098 4.87379C12.4231 5.19705 12.2469 5.50223 12.3318 5.81943L12.3385 5.84447L6.50608 15.9465Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42041 15.9695L6.63747 16.0947L12.4882 5.96086C12.8303 5.86922 13.0182 5.5437 13.2061 5.21834C13.3314 5.00146 13.8323 4.13368 14.0496 3.0061C13.1816 3.75792 12.6806 4.6257 12.5554 4.8426C12.3675 5.16798 12.1796 5.4935 12.2713 5.83562L6.42041 15.9695Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5793 15.9695L13.3623 16.0947L7.51158 5.96088C7.16944 5.86922 6.98156 5.54372 6.79368 5.21834C6.6684 5.00148 6.16744 4.13368 5.9502 3.0061C6.81814 3.75796 7.31914 4.6257 7.44438 4.84262C7.6323 5.168 7.82018 5.4935 7.72852 5.83564L13.5793 15.9695Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3394 16.1803L7.46999 6.01411C7.11905 5.90707 6.92619 5.57307 6.73955 5.24985C6.21763 4.34633 5.98879 3.53745 5.88869 3.01793L5.85449 2.84033L5.99119 2.95875C6.39079 3.30489 6.97667 3.90725 7.49859 4.81129C7.68531 5.13457 7.87821 5.46857 7.79539 5.82623L13.6649 15.9924L13.3394 16.1803ZM6.05057 3.17995C6.16511 3.68707 6.39345 4.40025 6.84791 5.18701C7.03457 5.51031 7.21077 5.81549 7.52779 5.90041L7.55283 5.90711L13.3852 16.0092L13.4938 15.9466L7.66129 5.84447L7.66801 5.81943C7.75297 5.50221 7.57673 5.19703 7.39013 4.87393C6.93557 4.08659 6.43227 3.53247 6.05057 3.17995Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5794 15.9695L13.3623 16.0947L7.51156 5.96086C7.16944 5.86922 6.98156 5.5437 6.79368 5.21834C6.66842 5.00146 6.16744 4.13368 5.9502 3.0061C6.81814 3.75792 7.31914 4.6257 7.4444 4.8426C7.63228 5.16798 7.82016 5.4935 7.72852 5.83562L13.5794 15.9695Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.02979 7.01406V13.0261H7.62047C7.99621 14.0281 9.24871 16.0321 10.0002 16.0321C10.7517 16.0321 12.0042 14.0281 12.38 13.0261H25.0302V7.01406H12.38C12.0042 6.01206 10.7517 4.00806 10.0002 4.00806C9.24871 4.00806 7.99621 6.01206 7.62047 7.01406H-5.02979Z",
    fill: "#BA2025"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3797 13.0259C12.7554 12.0239 13.0059 11.0219 13.0059 10.0199C13.0059 9.01792 12.7554 8.01592 12.3797 7.01392C12.0039 8.01592 11.7534 9.01792 11.7534 10.0199C11.7534 11.0219 12.0039 12.0239 12.3797 13.0259Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6204 13.0259C7.24464 12.0239 6.99414 11.0219 6.99414 10.0199C6.99414 9.01792 7.24464 8.01592 7.62038 7.01392C7.99612 8.01592 8.24662 9.01792 8.24662 10.0199C8.24664 11.0219 7.99614 12.0239 7.6204 13.0259Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.501 10.0201C10.501 10.4351 10.2768 10.7716 10 10.7716C9.72326 10.7716 9.49902 10.4351 9.49902 10.0201C9.49902 9.60503 9.72326 9.26855 10 9.26855C10.2768 9.26855 10.501 9.60503 10.501 10.0201Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1255 10.7527C10.1255 10.7527 10.6265 11.7547 10.6265 13.3829C10.6265 15.0112 10.1255 16.0132 10.1255 16.0132V10.7527Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87453 9.28736C9.87453 9.28736 9.37354 8.28536 9.37354 6.6571C9.37354 5.02884 9.87453 4.02686 9.87453 4.02686V9.28736Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87453 10.7527C9.87453 10.7527 9.37354 11.7547 9.37354 13.3829C9.37354 15.0112 9.87453 16.0132 9.87453 16.0132V10.7527Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_34_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_34_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1255 9.28736C10.1255 9.28736 10.6265 8.28536 10.6265 6.6571C10.6265 5.02884 10.1255 4.02686 10.1255 4.02686V9.28736Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.2426de4ed21ab51504c609a0e5897803.svg";
export { ForwardRef as ReactComponent };